import ReactQuill from 'react-quill-new';
 
import { useState, useEffect } from 'react';
import 'react-quill-new/dist/quill.snow.css'; 

export default function ConfigAlert({ block, setBlocks, updateBlock }) {

 
     

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
             
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
            ['clean'],
        ],
    };

    const formats = [
        'header', 'font', 'bold', 'italic', 'underline', 'strike',
        'color', 'background', 'align', 'list',
        'link',  
    ];

 
 

  

    function handleAlertTypeChange(e){
        
        
        updateBlock(block.id, 'alertType', e.target.value);
        block.alertType = e.target.value;
    
       
    }

    function handleAlertSizeChange(e){
  
        block.alertSize = e.target.value;
        const alertBgElem = document.getElementById(`alert-bg-${block.id}`);
        if (alertBgElem) {
            if (e.target.value == 'small') {
                alertBgElem.style.paddingTop = "0.05rem";
                alertBgElem.style.paddingBottom = "0.05rem";
            } else if (e.target.value == 'normal') {
                alertBgElem.style.paddingTop = "0.1rem";
                alertBgElem.style.paddingBottom = "0.3rem";
            } else if (e.target.value == 'large') {
                alertBgElem.style.paddingTop = "0.8rem";
                alertBgElem.style.paddingBottom = "0.8rem";
            } else if (e.target.value == 'xlarge') {
                alertBgElem.style.paddingTop = "1.25rem";
                alertBgElem.style.paddingBottom = "1.25rem";
            }
        }
        updateBlock(block.id, 'alertSize', e.target.value);
       
    }

    function handleAlertBorderChange(e){
        updateBlock(block.id, 'alertBorder', e.target.value);
        block.alertBorder = e.target.value;
    }

    function handleContentChange(value){
       
        updateBlock(block.id, 'content', value);
        block.content = value;
    }

   
    return (
        <div>
            <label className="block font-semibold mb-2">Texto:</label>
            <div className="p-2 bg-gray-100 rounded">
                <ReactQuill
                    value={block.content}
                    onChange={handleContentChange}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    preserveWhitespace={true}
                />
            </div>

            <label className="block font-semibold mb-2">Estilo:</label>
            <div className="p-2 bg-gray-100 rounded">
                <select className="w-full p-2 rounded" value={block.alertType} onChange={handleAlertTypeChange}>
                <option value="theme">Tema</option>

                    <option value="alert-info">Azul</option>
                    <option value="alert-success">Verde</option>
                    <option value="alert-warning">Amarelo</option>
                    <option value="alert-danger">Vermelho</option>
                    <option value="light">Claro</option>
                    <option value="dark">Escuro</option>
                </select>
            </div>

            <label className="block font-semibold mb-2">Espessura:</label>
            <div className="p-2 bg-gray-100 rounded">
                <select className="w-full p-2 rounded" value={block.alertSize} onChange={handleAlertSizeChange}>
                    <option value="small">Pequeno</option>
                    <option value="normal">Normal</option>
                    <option value="large">Grande</option>
                    <option value="xlarge">Muito grande</option>
                </select>
            </div>

            <label className="block font-semibold mb-2">Borda:</label>
            <div className="p-2 bg-gray-100 rounded">
                <select className="w-full p-2 rounded" value={block.alertBorder} onChange={handleAlertBorderChange}>
                    <option value="none">Sem borda</option>
                    <option value="normal">Borda normal</option>
                    <option value="dashed">Borda em Traço</option> 
                </select>
            </div>
        </div>
    );
}